import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

import { ErgebnisStorage } from '../data/ergebnis-storage.model';
import { Synopse } from '../data/ws/synopse.model';

@Injectable({
  providedIn: 'root',
})
export class ErgebnisDataService {
  private indikatorenErgebnisse: BehaviorSubject<Synopse[]> =
    new BehaviorSubject<Synopse[]>(null);
  currentErgebnisse = this.indikatorenErgebnisse.asObservable();

  private _ergebnisStorage: ErgebnisStorage;
  public get ergebnisStorage(): ErgebnisStorage {
    return this._ergebnisStorage;
  }
  public set ergebnisStorage(value: ErgebnisStorage) {
    this._ergebnisStorage = value;
  }

  setErgebnisStorage(ergebnisStorage: ErgebnisStorage) {
    for (let entry of ergebnisStorage.synopsen) {
      entry.tierart = entry.tierart.replace(' ', '\n');
    }

    this.ergebnisStorage = ergebnisStorage;
    this.indikatorenErgebnisse.next(ergebnisStorage.synopsen);
  }
}
